import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container py-4 " style={{ marginTop: "50px" }}>
      <h2 className="mb-3">Privacy Policy – CrickPay</h2>

      <p>
        CrickPay is a cricket academy management application designed for
        Admins, Coaches, and Players. This Privacy Policy explains how we
        collect, use, and protect your information when using the CrickPay app.
      </p>

      <h5 className="mt-4">1. Types of Users</h5>
      <ul>
        <li>
          <strong>Admin:</strong> Manages academy operations and user accounts.
        </li>
        <li>
          <strong>Coach:</strong> Marks attendance and manages training
          sessions.
        </li>
        <li>
          <strong>Player:</strong> Views attendance, training details, and
          academy updates.
        </li>
      </ul>

      <h5 className="mt-4">2. Information We Collect</h5>
      <ul>
        <li>Name, email address, and phone number.</li>
        <li>Player and coach profile information.</li>
        <li>Attendance records.</li>
        <li>Uploaded images for attendance verification.</li>
        <li>Device information and usage data.</li>
      </ul>

      <h5 className="mt-4">3. Location Data</h5>
      <p>
        The CrickPay app may collect location information from Coaches when
        marking attendance to verify the correct training ground location.
        Location data is only used for attendance verification.
      </p>

      <h5 className="mt-4">4. Image Upload & Storage</h5>
      <p>
        Coaches may upload images when marking attendance for players. These
        images are securely stored and used only for attendance verification and
        academy management purposes.
      </p>

      <h5 className="mt-4">5. Push Notifications</h5>
      <p>
        The app may send push notifications to inform users about attendance
        updates, training schedules, announcements, and important academy
        information.
      </p>

      <h5 className="mt-4">6. Data Security</h5>
      <p>
        We implement appropriate technical and organizational security measures
        to protect user data from unauthorized access, loss, misuse, or
        alteration.
      </p>

      <h5 className="mt-4">7. Changes to This Policy</h5>
      <p>
        We may update this Privacy Policy from time to time. Updates will be
        posted on this page and users are encouraged to review it periodically.
      </p>

      <h5 className="mt-4">8. Contact Us</h5>
      <p>If you have questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li>Email: info@crickpay.net</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
